<!-- KPI SECTION -->
<div class="row mb-3">
    <!-- <div class="chart-container"> -->
    <div class="col-md-3">
        <img [src]="defaultImageSrc" />
    </div>
    <div class="col-md-3 chart-container">
        <!-- TOTAL -->
        <div class="chart-box">
            <h3>Total</h3>
            <dx-chart [dataSource]="dashboardData?.summary?.totalSummary" [rotated]="true">
                <dxi-series type="bar" argumentField="name" valueField="value" color="#FFC107"> </dxi-series>

                <dxo-legend [visible]="false"></dxo-legend>

                <dxi-value-axis>
                    <dxo-label [customizeText]="formatExactValue"> </dxo-label>

                    <dxo-grid [visible]="true" color="#e0e0e0"></dxo-grid>
                    <dxo-tick [visible]="false"></dxo-tick>
                    <dxo-minor-tick [visible]="false"></dxo-minor-tick>
                </dxi-value-axis>
                <dxo-common-axis-settings>
                    <dxo-tick [visible]="false"></dxo-tick>
                    <dxo-minor-tick [visible]="false"></dxo-minor-tick>
                </dxo-common-axis-settings>
            </dx-chart>
        </div>
    </div>
    <div class="col-md-3 chart-container">
        <!-- EIS -->
        <div class="chart-box">
            <h3>EIS</h3>
            <dx-chart [dataSource]="dashboardData?.summary?.eisSummary" [rotated]="true">
                <dxi-series type="bar" argumentField="name" valueField="value" color="#000000"> </dxi-series>

                <dxo-legend [visible]="false"></dxo-legend>
                <dxi-value-axis>
                    <dxo-label [customizeText]="formatExactValue"> </dxo-label>

                    <dxo-grid [visible]="true" color="#e0e0e0"></dxo-grid>
                    <dxo-tick [visible]="false"></dxo-tick>
                    <dxo-minor-tick [visible]="false"></dxo-minor-tick>
                </dxi-value-axis>
                <dxo-common-axis-settings>
                    <dxo-tick [visible]="false"></dxo-tick>
                    <dxo-minor-tick [visible]="false"></dxo-minor-tick>
                </dxo-common-axis-settings>
            </dx-chart>
        </div>
    </div>
    <div class="col-md-3 chart-container">
        <!-- NEIS -->
        <div class="chart-box">
            <h3>NEIS</h3>
            <dx-chart [dataSource]="dashboardData?.summary?.neisSummary" [rotated]="true">
                <dxi-series type="bar" argumentField="name" valueField="value" color="#BDBDBD"> </dxi-series>

                <dxo-legend [visible]="false"></dxo-legend>
                <dxi-value-axis>
                    <dxo-label [customizeText]="formatExactValue"> </dxo-label>

                    <dxo-grid [visible]="true" color="#e0e0e0"></dxo-grid>
                    <dxo-tick [visible]="false"></dxo-tick>
                    <dxo-minor-tick [visible]="false"></dxo-minor-tick>
                </dxi-value-axis>
                <dxo-common-axis-settings>
                    <dxo-tick [visible]="false"></dxo-tick>
                    <dxo-minor-tick [visible]="false"></dxo-minor-tick>
                </dxo-common-axis-settings>
            </dx-chart>
        </div>
    </div>
    <!-- </div> -->
</div>
<br />
<!-- EQUIPMENT STATUS -->
<div class="card_gridTwo">
    <app-summary-table [tableData]="dashboardData?.blocks"></app-summary-table>
</div>
<div class="row mb-3">
    <app-custom-kpi-bar [kpiData]="dashboardData?.kpiPercentages"></app-custom-kpi-bar>
</div>

<!-- TOP SUMMARY CHARTS -->
<div class="row mb-3">
    <app-summary-bar-chart [charts]="dashboardData?.charts"> </app-summary-bar-chart>
</div>
